require('./skin/skin.less');

var Cortona3DSolo = require('solo');

var usedSkins = {},
    UISkinController = require('./skin/UISkinController'),
    util = require('lib/util');

var m_options = {};


/**
 * A simple User Interface (UI) helper object.
 * 
 * Requires the use of the internal module `"skin"`.
 * 
 * @namespace
 * @memberof module:solo
 * @since 1.6.0
 * @example
Cortona3DSolo.use('skin', {
    baseUrl: 'uniview/'
});
Cortona3DSolo.skin.create('app').use('solo-uniview', {
    src: 'procedure.interactivity.xml'
});
 */
var skin = {
    /**
     * @class The constructor creates an instance of {@link UISkinController} object.
     * @see UISkinController
     */
    UISkinController: UISkinController,

    /**
     * Creates a new skin area with given name in the coordinates of the base element.
     * 
     * @param {string} name
     * @param {HTMLElement|CSSSelector} [baseElement=document.body] HTML node or CSS selector
     * @returns {UISkinController}
     */
    create: function (name, baseElement) {
        if (!usedSkins[name]) {
            usedSkins[name] = new skin.UISkinController(name, (typeof baseElement === 'string' ? document.querySelector(baseElement) : baseElement));
        }
        return usedSkins[name];
    },

    /**
     * Removes the skin area with the given name.
     * 
     * @param {string} name
     */
    remove: function (name) {
        if (usedSkins[name]) {
            // detach?
            delete usedSkins[name];
        }
    },

    /**
     * Gets the skin area controller with the given name.
     * 
     * @param {string} name
     * @returns {UISkinController}
     */
    get: function (name) {
        return usedSkins[name];
    },

    /**
     * Loads the component module using `requirejs` configured with the `"skin"` module options and returns the factory function of the component.
     * 
     * @async
     * @param {string} name
     * @returns {Promise.<UISkinComponentFactory>} The Promise object whose fulfillment handler receives the factory function when the requested external component file has successfully been loaded.
     */
    require: function (name) {
        return Cortona3DSolo.app.util.requirePromise(name, window.requirejs.config(m_options));
    }
};

module.exports = {
    configure: function (options) {
        m_options = util.expand({}, options || {});
        return {
            skin: skin
        };
    }
};